import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import React from "react";
import { ButtonSecondaryRedSkin, Link, Metrics, ButtonPrimaryRedSkin } from "@origin-digital/style-guide";
import { navTo } from "@origin-digital/event-dispatcher";
import styled from "styled-components";
import { shouldUseEventDispatch, getAppNameForNavTo } from "../NextBestAction.utils";
export var StyledLink = styled(Link).withConfig({
  displayName: "CTALink__StyledLink",
  componentId: "sc-184193-0"
})(["font-size:", "px;text-decoration:none !important;"], Metrics.FontSizes.BODY);
export var CTALink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CTALink, _React$Component);

  function CTALink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CTALink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CTALink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleEventDispatch", function (event) {
      var _this$props = _this.props,
          buttonLink = _this$props.buttonLink,
          caids = _this$props.caids;
      event.preventDefault();
      var appName = getAppNameForNavTo(buttonLink);
      var navigate = navTo[appName];

      if (navigate) {
        var params = caids ? {
          caids: caids
        } : undefined;
        navigate(params);
      } else {
        throw new Error("Unsupported navigation for personalisation link ".concat(buttonLink));
      }
    });

    return _this;
  }

  _createClass(CTALink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          buttonLink = _this$props2.buttonLink,
          newTab = _this$props2.newTab,
          kind = _this$props2.kind;
      var useEventDispatch = shouldUseEventDispatch(buttonLink);
      return React.createElement(StyledLink, {
        href: buttonLink,
        target: newTab ? "_blank" : "_self",
        onClick: useEventDispatch ? this.handleEventDispatch : undefined,
        "data-id": "next-best-action-button",
        trackingDisabled: true
      }, kind === "primary" ? React.createElement(ButtonPrimaryRedSkin, null, children) : React.createElement(ButtonSecondaryRedSkin, null, children));
    }
  }]);

  return CTALink;
}(React.Component);